// extracted by mini-css-extract-plugin
module.exports = {"remove":"HookForm_remove__1xzF7","container":"HookForm_container__1VFgl"};